module.exports = __webpack_public_path__ + "img/medal_2.e196d901.png";